import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_EXAM_FEE_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostExamFeeRequest {
  registrationExamLevelUuid: string;
  year: number;
  gstPercent: number;
  gstInclusive: boolean;
  registrationFee: number;
  lateRegistrationFee: number;

  // Field for AEIS Exam
  admissionLevelCodes?: string[];

  // Field for SPERS Exam
  firstTimerRegistrationFee?: number;
  secondTimerRegistrationFee?: number;
  firstTimerLateFee?: number;
  secondTimerLateFee?: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostExamFee = ({ onSuccess, onError }: Input) => {
  const postExamFee = async (payload: PostExamFeeRequest) => {
    const res = await axiosClient.post<void>(POST_EXAM_FEE_URL, payload);
    return res.data;
  };

  return useCustomMutation(postExamFee, {
    onSuccess,
    onError,
  });
};
